export function EmptyState({ title, description, cta, icon: Icon }) {
  return (
    <div className="text-center p-8 rounded-2xl border border-dashed border-border bg-card">
      {Icon && (
        <div className="mx-auto mb-3 h-12 w-12 rounded-full bg-primary/10 grid place-items-center text-primary">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="text-base font-semibold bb-display">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
